import { useSelector } from 'react-redux';

import { CountryDirectionType } from '../../../../entities/providers/hooks/hooks.type';

import { isRusPost, Providers } from '../../../../config/providers';

import * as fromProviders from '../../../../entities/providers/selectors';
import * as fromRates from '../../../../entities/rates/selectors';

function useProvider(type: CountryDirectionType): Providers {
  const selector = type === 'sender' ? fromProviders.getCurrentProvider : fromProviders.getInboundProvider;

  return useSelector(selector);
}

export function useRegionDisabled(type: CountryDirectionType): boolean {
  const provider = useProvider(type);

  const isCourier = useSelector(fromRates.isCourierDelivery);

  // noinspection RedundantIfStatementJS
  if (isRusPost(provider) && !isCourier) {
    return false;
  }

  return true;
}
